<template>
  <div>
    <modal
      name="tour-modal"
      width="800px"
      height="auto"
      :adaptive="true"
      :click-to-close="true"
      :scrollable="true"
    >
      <div class="tour-modal">
        <img :src="require('../../../../assets/tour-intro.png')" />
        <div class="tour-modal__info">
          <span class="font-12">{{
            $t('wizard-v2.tour.modal.whats-new')
          }}</span>
          <h4 class="font-20">
            {{ $t('wizard-v2.tour.modal.discover-print-wizard') }}
          </h4>

          <div class="mt-15">
            <info-box
              :icon="CloudUpload16"
              :title="$t('wizard-v2.tour.modal.easy-upload')"
              :text="$t('wizard-v2.tour.modal.quick-upload-images')"
            />
            <info-box
              :icon="TextCreation16"
              :title="$t('wizard-v2.tour.modal.add-customised-text')"
              :text="$t('wizard-v2.tour.modal.pesonalise-your-product')"
            />
            <info-box
              :icon="Select02"
              :title="$t('wizard-v2.tour.modal.quickly-set-print-positions')"
              :text="$t('wizard-v2.tour.modal.effortlessly-adjust')"
            />
            <info-box
              :icon="View16"
              :title="$t('wizard-v2.tour.modal.instant-preview-product')"
              :text="$t('wizard-v2.tour.modal.see-exactly-how-item-will-look')"
            />
          </div>

          <div class="tour-modal__info--buttons">
            <cv-button
              id="preview-text-btn"
              kind="primary"
              :label="$t('wizard-v2.tour.modal.discover-new-features')"
              text="center"
              @click="$emit('start-tour')"
            >
              {{ $t('wizard-v2.tour.modal.discover-new-features') }}
            </cv-button>
            <cv-button
              id="preview-text-btn"
              kind="ghost"
              :label="$t('wizard-v2.tour.modal.skip-tour')"
              text="center"
              @click="$emit('close-tour-modal')"
            >
              {{ $t('wizard-v2.tour.modal.skip-tour') }}
            </cv-button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import Vue from 'vue';
import InfoBox from './InfoBox.vue';
import TextCreation16 from '@carbon/icons-vue/es/text--creation/16';
import CloudUpload16 from '@carbon/icons-vue/es/cloud--upload/16';
import Select02 from '@carbon/icons-vue/es/select--02/16';
import View16 from '@carbon/icons-vue/es/text--creation/16';
import { CvButton } from '@carbon/vue';

export default Vue.extend({
  name: 'TourModal',
  components: { InfoBox, CvButton },
  data() {
    return {
      TextCreation16,
      CloudUpload16,
      Select02,
      View16,
    };
  },
});
</script>
<style lang="scss">
.tour-modal {
  display: flex;

  img {
    width: 505px;
    object-fit: cover;
  }

  &__info {
    padding: 32px;

    width: 295px;

    &--buttons {
      margin-top: 30px;
    }

    &--buttons .cv-button {
      display: flex;
      flex-direction: column;
      width: 100%;
      font-size: 14px;
      justify-content: center;
      padding: 10px;
    }
  }
}
</style>
